import { render, staticRenderFns } from "./RegisBBI.vue?vue&type=template&id=cf66678e&scoped=true&"
import script from "./RegisBBI.vue?vue&type=script&lang=js&"
export * from "./RegisBBI.vue?vue&type=script&lang=js&"
import style0 from "./RegisBBI.vue?vue&type=style&index=0&id=cf66678e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf66678e",
  null
  
)

export default component.exports